import { WprBaseService } from '../wpr-framework/service/WprBaseService';
import { HttpUtils } from '../common/http/HttpUtils';

/**
 * サービス基本クラス
 */
export class TestBaseService extends WprBaseService {
	// public メソッド  ----------------------------------------------------------
	/**
	 * POST通信処理
	 * @param url URL
	 * @param request リクエスト情報
	 * @returns 通信結果Promiseオブジェクト
	 */
	public async executePost(url: string, request: any): Promise<any> {
		return await HttpUtils.doPost_t(url, request);
		// return await HttpUtils.doPost(url, request);
	}
	// --------------------------------------------------------------------------
}